import React from 'react';

function Footer() {
  return (
    <section className="footer-container">
      <div className="container">
        <div className="footer-content">
          <span>This site is hosted and maintained by Stanford University</span>
        </div>
      </div>
    </section>
  );
}

export default Footer;
